
import Request from './reqeust';

// 获取usersig
export function getImUserSig() {
    return Request({
        url: '/api/account-center/getImUserSig',
        method: 'get',
        params: {}
    })
}

// 银联上传文件
export function uploadUnion(name,type) {
    return Request({
        url: '/api/front-file/uploadUnion',
        method: 'post',
        formData: {
          document_name:name,
          document_type:type,
        }
    })
}

// 物流订单确认送达
export function logisticsOrderDelivery(_logisticsOrderId) {
    return Request({
        url: '/api/order/logisticsOrderDelivery',
        method: 'get',
        params: {logisticsOrderId:_logisticsOrderId}
    })
}

// 支行查询
export function zhihang() {
    return Request({
        url: '/api/union-pay-certification/branchBankList',
        method: 'get',
        params: {}
    })
}

// 提交银联认证
export function fastUserInfoUpload(_params) {
    return Request({
        url: '/api/union-pay-certification/fastUserInfoUpload',
        method: 'post',
        params: _params
    })
}

// 下单
export function xiadan() {
    return Request({
        url: 'http://58.247.0.18:29015/v1/netpay/upg/order',
        method: 'get',
        params: {}
    })
}

// 扫码
export function saoma() {
    return Request({
        url: 'https://api-mop.chinaums.com/v1/netpay/bills/get-qrcode',
        method: 'post',
        params: {}
    })
}

//

//用户信息
export function getUserInfo() {
    return Request({
        url: 'api/account-center/info',
        method: 'get',
        params: {}
    })
}

//更新用户基础信息
export function updateUserBasicInfo(_params) {
    return Request({
        url: 'api/account-center/syncInfoPc',
        method: 'post',
        params:_params
    })
}

//重置密码
export function resetPwd(_params) {
    return Request({
        url: 'api/account/resetPass',
        method: 'post',
        params: _params
    })
}

//修改手机号
export function updateMobile(_params) {
    return Request({
        url: 'api/account-center/modifyPhone',
        method: 'post',
        params: _params
    })
}

//消息通知
export function pushMessageList(_params) {
    return Request({
        url: 'api/account-center/pushMessageList',
        method: 'get',
        params: _params
    })
}

//地址列表
export function getAddressList() {
    return Request({
        url: 'api/account-center/getUserAddressList',
        method: 'get',
        params: {}
    })
}

//添加用户地址
export function addAddress(_params) {
    return Request({
        url: 'api/account-center/addUserAddress',
        method: 'post',
        params:_params
    })
}

//是否默认地址
export function isDefaultAddress(_params) {
    return Request({
        url: 'api/account-center/isDefaultAddress',
        method: 'get',
        params:_params
    })
}

//获取默认地址
export function getDefaultAddr() {
    return Request({
        url: 'api/account-center/getUserDefaultAddress',
        method: 'get',
        params:{}
    })
}


//修改地址
export function editAddress(_params) {
    return Request({
        url: 'api/account-center/updateUserAddress',
        method: 'post',
        params:_params
    })
}

//删除地址
export function delAddress(_id) {
    return Request({
        url: 'api/account-center/delUserAddress/'+_id,
        method: 'get',
        params:{}
    })
}

//我的营销视频列表
export function myReleaseVideos(_params) {
    return Request({
        url: 'pc/home/marketVideo',
        method: 'get',
        params:_params
    })
}

//我的发布列表
export function getMySupplyAndDemand(_params) {
    return Request({
        url: '/api/company/getMySupplyAndDemand',
        method: 'get',
        params:_params
    })
}

//删除发布列表
export function deleteSupplyAndDemand(_params) {
    return Request({
        url: '/api/company/deleteSupplyAndDemand',
        method: 'get',
        params:_params
    })
}

//取消贸易订单
export function cancelTradeOrder(_params) {
    return Request({
        url: 'api/order/cancelTradeOrder',
        method: 'post',
        params:_params
    })
}

//物流订单
export function logisticsOrders(_params) {
    return Request({
        url: 'pc/account-center/logisticsOrders',
        method: 'get',
        params:_params
    })
}

//汽运订单
export function trucksOrders(_params) {
    return Request({
        url: '/pc/account-center/trucksOrders',
        method: 'get',
        params:_params
    })
}

//贸易订单
export function tradeOrders(_params) {
    return Request({
        url: 'pc/account-center/tradeOrders',
        method: 'get',
        params:_params
    })
}

//汽运发货列表
export function logisticsDeliveryTrucks(_params) {
    return Request({
        url: 'pc/order/logisticsDeliveryTrucks',
        method: 'get',
        params:_params
    })
}

//保单订单列表
export function insuranceOrders() {
    return Request({
        url: 'pc/account-center/insuranceOrderList',
        method: 'get',
        params: {}
    })
}


//获取入驻身份
export function getEnterIdentitys() {
    return Request({
        url: 'api/enter/view',
        method: 'get',
        params: {}
    })
}

//门店缴费订单列表
export function shopPayOrderDataList() {
    return Request({
        url: '/api/order/shopPayOrderDataList',
        method: 'get',
        params: {}
    })
}

//门店缴费订单申请发票
export function applyShopPayOrderInvoice(_params) {
    return Request({
        url: '/api/order/applyShopPayOrderInvoice',
        method: 'post',
        params: _params
    })
}

//门店缴费订单发送发票
export function sendInvoice(_params) {
    return Request({
        url: '/api/account-center/sendInvoice',
        method: 'post',
        params: _params
    })
}


//关于平台
export function getAbout() {
    return Request({
        url: 'pc/account-center/aboutUs',
        method: 'get',
        params: {}
    })
}


//获取重置密码验证码
export function getResetPwdSmsCode(_params) {
    return Request({
        url: 'api/account/reqResetPassSMS',
        method: 'get',
        params: _params
    })
}

//更换手机号校验验证码
export function validateSmsCode(_params) {
    return Request({
        url: 'api/account-center/validationCodeToModifyPhone',
        method: 'get',
        params: _params
    })
}

// 我的粉丝
export function getFans(_params) {
    return Request({
        url: 'api/account-center/fans',
        method: 'get',
        params: _params
    })
}

//我的关注
export function getAttentions(_params) {
    return Request({
        url: 'pc/account-center/attentions',
        method: 'get',
        params: _params
    })
}

//关注、取消关注
export function attentionFor(_params) {
    return Request({
        url: 'api/company-details/attention',
        method: 'get',
        params: _params
    })
}

//入驻
export function saveEnter(_params) {
    return Request({
        url: 'api/enter/saveInfo',
        method: 'post',
        params: _params
    })
}

//重新入驻
export function againAudit(_params) {
    return Request({
        url: 'api/enter/againAudit',
        method: 'post',
        params: _params
    })
}

//获取审核
export function getAudit(_params) {
    return Request({
        url: 'api/enter/getAudit',
        method: 'get',
        params: _params
    })
}

//贸易订单下单
export function addTradeOrder(_params) {
    return Request({
        url: 'api/order/addTradeOrder',
        method: 'post',
        params: _params
    })
}


//经营数据
export function getUserRunningWater(_params) {
    return Request({
        url: 'pc/account-center/getUserRunningWater',
        method: 'get',
        params: _params
    })
}

//用户流水
export function userRunningWater(_params) {
    return Request({
        url: '/api/account-center/userRunningWater',
        method: 'get',
        params: _params
    })
}


//获取发票列表
export function invoiceList(_params) {
    return Request({
        url: 'pc/account-center/invoiceList',
        method: 'get',
        params: _params
    })
}



//获取发票详情
export function getLogisticsDeliveryInvoiceInfo(_id) {
    return Request({
        url: 'api/order/getLogisticsDeliveryInvoiceInfo',
        method: 'get',
        params: {logisticsInvoiceId:_id}
    })
}

//获取保单详情
export function insuranceOrderInfo(_idOrNo) {
    return Request({
        url: 'api/order/insuranceOrderInfo',
        method: 'get',
        params: {idOrNo:_idOrNo}
    })
}

//发送保险信息至邮箱
export function sendInsuranceEmail(_params) {
    return Request({
        url: 'api/order/sendInsuranceEmail',
        method: 'get',
        params:_params
    })
}

//用户中心今日售价
export function ucNowDataPrice(_params) {
    return Request({
        url: 'pc/home/nowDataPrice',
        method: 'get',
        params:_params
    })
}

//用户中心今日售价-统计数
export function todayPriceNumInfo(_params) {
    return Request({
        url: 'pc/account-center/todayPriceNumInfo',
        method: 'get',
        params:_params
    })
}


//用户中心今日收购价
export function ucNowDataPurchase(_params) {
    return Request({
        url: 'pc/home/nowDataPurchase',
        method: 'get',
        params:_params
    })
}

//用户中心今日收购价-统计数
export function todayBuyNumInfo(_params) {
    return Request({
        url: 'pc/account-center/todayBuyNumInfo',
        method: 'get',
        params:_params
    })
}

//删除视频
export function deleteVideo(_id) {
    return Request({
        url: 'api/account-center/deleteVideo',
        method: 'get',
        params:{marketingVideoId:_id}
    })
}

//获取局站列表
export function getCompanyStandInfo() {
    return Request({
        url: 'api/company/getCompanyStandInfo',
        method: 'get',
        params:{}
    })
}

//获取局站列表
export function addStand(_params) {
    return Request({
        url: 'api/enter/addStand',
        method: 'post',
        params:_params
    })
}

//贸易订单预支付
export function tradeOrderPrepaid(_params) {
    return Request({
        url: 'api/order/tradeOrderPrepaid',
        method: 'post',
        params:_params
    })
}

//企业信息
export function companyDetail(_id) {
    return Request({
        url: 'api/company/getSyncInfo',
        method: 'get',
        params:{companyId:_id}
    })
}

//企业注销
export function cancellation(_params) {
    return Request({
        url: 'api/company/cancellation',
        method: 'post',
        params:_params
    })
}
//更新企业信息
export function syncCompanyInfo(_params) {
    return Request({
        url: 'api/company/sync',
        method: 'post',
        params:_params
    })
}

//获取物流订单详情
export function getLogisticsOrderDetailInfo(_type,_orderNo) {
    return Request({
        url: 'api/order/getLogisticsOrderDetailInfo',
        method: 'get',
        params:{type:_type,orderNo:_orderNo}
    })
}

//获取汽运订单详情
export function trucksOrderDetailedInfo(_type,_orderNo) {
    return Request({
        url: 'api/order/trucksOrderDetailedInfo',
        method: 'get',
        params:{type:_type,idOrNo:_orderNo}
    })
}

//获取贸易订单详情
export function getTradeOrderInfo(_orderNo) {
    return Request({
        url: 'api/order/getTradeOrderInfo',
        method: 'get',
        params:{orderNo:_orderNo}
    })
}

//汽运订单报价
export function trucksOffer(_params) {
    return Request({
        url: 'api/order/trucksOffer',
        method: 'post',
        params:_params
    })
}
//取消汽运订单报价
export function cancelTrucksOrderOffer(_id) {
    return Request({
        url: 'api/order/cancelTrucksOrderOffer',
        method: 'get',
        params:{offerId:_id}
    })
}

//修改贸易订单价格
export function updateTradeOrderTotalPrice(_params) {
    return Request({
        url: 'api/order/updateTradeOrderTotalPrice',
        method: 'post',
        params:_params
    })
}

//贸易订单发货
export function tradeOrderDelivery(_params) {
    return Request({
        url: 'api/order/tradeOrderDelivery',
        method: 'post',
        params:_params
    })
}

// 同意退款
export function confirmTradeRefund(_tradeOrderId) {
    return Request({
        url: '/api/order/confirmTradeRefund',
        method: 'get',
        params:{tradeOrderId:_tradeOrderId}
    })
}

//贸易订单确认收货
export function tradeOrderReceipt(_tradeOrderId,_code) {
    return Request({
        url: 'api/order/tradeOrderReceipt',
        method: 'get',
        params:{tradeOrderId:_tradeOrderId, code:_code}
    })
}


//贸易订单划款
export function partialCrossSection(_params) {
    return Request({
        url: '/api/order/partialCrossSection',
        method: 'post',
        params:_params
    })

}


//贸易订单评价
export function tradeOrderEvaluation(_params) {
    return Request({
        url: 'api/order/tradeOrderEvaluation',
        method: 'post',
        params:_params
    })
}


//获取登录验证码
export function reqLoginCode(_phone) {
    return Request({
        url: 'api/account/reqLoginCode',
        method: 'get',
        params:{areaCode:'86',phone:_phone}
    })
}


//添加物流订单报价
export function addLogisticsDeliveryCompanyOfferInfo(_params) {
    return Request({
        url: 'api/order/addLogisticsDeliveryCompanyOfferInfo',
        method: 'post',
        params:_params
    })
}

//取消物流订单报价
export function cancelCompanyOfferInfo(_id) {
    return Request({
        url: 'api/order/cancelCompanyOfferInfo',
        method: 'get',
        params:{logisticsDeliveryCompanyOfferInfoId:_id}
    })
}

//申请取消物流订单
export function cancelLogisticsOrder(_params) {
    return Request({
        url: 'api/order/cancelLogisticsOrder',
        method: 'post',
        params:_params
    })
}


//取消物流订单
export function confirmCancelLogisticsOrder(_id) {
    return Request({
        url: 'api/order/confirmCancelLogisticsOrder',
        method: 'get',
        params:{logisticsOrderId:_id}
    })
}


//物流订单预支付
export function logisticsOrderPrepaid(_params) {
    return Request({
        url: 'api/order/logisticsOrderPrepaid',
        method: 'post',
        params:_params
    })
}

//物流订单确认收货
export function logisticsOrderReceipt(_logisticsOrderId) {
    return Request({
        url: 'api/order/logisticsOrderReceipt',
        method: 'get',
        params:{logisticsOrderId:_logisticsOrderId}
    })
}



//物流订单评价
export function logisticsOrderEvaluate(_params) {
    return Request({
        url: 'api/order/logisticsOrderEvaluate',
        method: 'post',
        params:_params
    })
}



//汽运订单预支付
export function logisticsTrucksOrderPrepaid(_params) {
    return Request({
        url: 'api/order/logisticsTrucksOrderPrepaid',
        method: 'post',
        params:_params
    })
}

// 汽运订单确认送达
export function trucksOrderDelivery(_logisticsTrucksOrderId) {
    return Request({
        url: 'api/order/trucksOrderDelivery',
        method: 'get',
        params:{logisticsTrucksOrderId:_logisticsTrucksOrderId}
    })
}

//汽运订单通知取货
export function notifyDriverPickUpGoods(_params) {
    return Request({
        url: 'api/order/notifyDriverPickUpGoods',
        method: 'post',
        params:_params
    })
}


//汽运订单申请取消
export function cancelLogisticsTrucksOrder(_params) {
    return Request({
        url: 'api/order/cancelLogisticsTrucksOrder',
        method: 'post',
        params:_params
    })
}


//汽运订单同意取消
export function confirmCancelLogisticsTrucksOrder(_id) {
    return Request({
        url: 'api/order/confirmCancelLogisticsTrucksOrder',
        method: 'get',
        params:{logisticsTrucksOrderId:_id}
    })
}


//汽运订单确认收货
export function trucksOrderReceipt(_id) {
    return Request({
        url: 'api/order/trucksOrderReceipt',
        method: 'get',
        params:{logisticsTrucksOrderId:_id}
    })
}





//汽运订单评价
export function logisticsTrucksOrderEvaluate(_params) {
    return Request({
        url: 'api/order/logisticsTrucksOrderEvaluate',
        method: 'post',
        params:_params
    })
}


//获取缴费列表
export function storePaymentAllocationView(_standId) {
    return Request({
        url: 'api/order/storePaymentAllocationView',
        method: 'get',
        params:{standId:_standId}
    })
}

//生成缴费订单
export function createdShopPayOrder(_params) {
    return Request({
        url: 'api/order/createdShopPayOrder',
        method: 'post',
        params:_params
    })
}

//门店缴费续费预支付
export function shopPay(_params) {
    return Request({
        url: 'api/order/shopPay',
        method: 'post',
        params:_params
    })
}

//门店缴费续费预支付使用代金券
export function useVouchers(_params) {
    return Request({
        url: 'api/order/useVouchers',
        method: 'post',
        params:_params
    })
}

//保险订单预支付
export function insuranceOrderPrepaid(_params) {
    return Request({
        url: 'api/order/insuranceOrderPrepaid',
        method: 'post',
        params:_params
    })
}

//获取最新发票
export function getUserInvoice() {
    return Request({
        url: 'api/account-center/getUserInvoice',
        method: 'get',
        params:{}
    })
}

///api/account-center/getUserInvoice

///api/order/insuranceOrderPrepaid

///api/order/shopPay

///api/order/createdShopPayOrder

//api/order/storePaymentAllocationView



// WEBPACK FOOTER //
// ./src/services/usercenter.js